module.exports = __webpack_public_path__ + "08f0961f2cfc1438f1c9f2662671195e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/termine/Sema.jpg
// module id = 718
// module chunks = 0